module.exports = __webpack_public_path__ + "media/images/home/produto_bdh-39e36c277f85cf7d39adc2ddddbb3ee3.png";